<p-dialog
  [header]="'vcuPair.dialog.title' | transloco"
  [(visible)]="visible"
  [modal]="true"
  [closable]="state !== 'generating'"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '540px', maxWidth: '95vw' }"
  (onShow)="onDialogShow()"
  (onHide)="onDialogHide()"
  styleClass="vcu-pair-dialog"
>
  <!-- Estado: Gerando código -->
  <div *ngIf="state === 'generating'" class="pair-state pair-state-generating">
    <p-progressSpinner
      [style]="{ width: '60px', height: '60px' }"
      strokeWidth="4"
      animationDuration="1s"
    ></p-progressSpinner>
    <p class="generating-text">{{ 'vcuPair.dialog.generating' | transloco }}</p>
  </div>

  <!-- Estado: Código gerado -->
  <div *ngIf="state === 'code-ready'" class="pair-state pair-state-ready">
    <div class="pair-instruction">
      <i class="pi pi-desktop pair-icon"></i>
      <p>{{ 'vcuPair.dialog.instruction' | transloco }}</p>
    </div>

    <div class="code-display">
      <span *ngFor="let digit of codeDigits" class="code-digit">{{ digit }}</span>
    </div>

    <div class="timer-container" [class.timer-critical]="isTimerCritical">
      <i class="pi pi-clock"></i>
      <span>{{ 'vcuPair.dialog.expiresIn' | transloco }}: {{ timerDisplay }}</span>
    </div>

    <p class="pair-hint">{{ 'vcuPair.dialog.hint' | transloco }}</p>

    <div class="pair-actions">
      <p-button
        [label]="'vcuPair.dialog.newCode' | transloco"
        icon="pi pi-refresh"
        severity="secondary"
        [raised]="true"
        (click)="generateCode()"
        styleClass="pair-action-btn"
      ></p-button>
      <p-button
        [label]="'vcuPair.dialog.cancel' | transloco"
        severity="danger"
        [raised]="true"
        [outlined]="true"
        (click)="closeDialog()"
        styleClass="pair-action-btn"
      ></p-button>
    </div>
  </div>

  <!-- Estado: Código expirado -->
  <div *ngIf="state === 'expired'" class="pair-state pair-state-expired">
    <div class="expired-icon-wrapper">
      <i class="pi pi-clock expired-icon"></i>
    </div>
    <h3 class="expired-title">{{ 'vcuPair.dialog.expiredTitle' | transloco }}</h3>
    <p class="expired-message">{{ 'vcuPair.dialog.expiredMessage' | transloco }}</p>

    <div class="pair-actions">
      <p-button
        [label]="'vcuPair.dialog.newCode' | transloco"
        icon="pi pi-refresh"
        severity="danger"
        [raised]="true"
        (click)="generateCode()"
        styleClass="pair-action-btn"
      ></p-button>
      <p-button
        [label]="'vcuPair.dialog.cancel' | transloco"
        severity="secondary"
        [raised]="true"
        (click)="closeDialog()"
        styleClass="pair-action-btn"
      ></p-button>
    </div>
  </div>

  <!-- Estado: Pareamento detectado (sucesso) -->
  <div *ngIf="state === 'success'" class="pair-state pair-state-success">
    <div class="success-icon-wrapper">
      <i class="pi pi-check-circle success-icon"></i>
    </div>
    <h3 class="success-title">{{ 'vcuPair.dialog.successTitle' | transloco }}</h3>
    <p class="success-message">{{ 'vcuPair.dialog.successMessage' | transloco }}</p>

    <div *ngIf="pairedVcu" class="success-vcu-info">
      <div class="success-vcu-detail">
        <span class="success-label">{{ 'vcuPair.card.model' | transloco }}:</span>
        <span class="success-value">{{ pairedVcu.modelDescription || pairedVcu.vehicleModel || '-' }}</span>
      </div>
      <div class="success-vcu-detail">
        <span class="success-label">S/N:</span>
        <span class="success-value success-serial">{{ displaySerial }}</span>
      </div>
    </div>

    <div class="pair-actions">
      <p-button
        [label]="'vcuPair.dialog.close' | transloco"
        icon="pi pi-check"
        severity="success"
        [raised]="true"
        (click)="closeDialog()"
        styleClass="pair-action-btn"
      ></p-button>
    </div>
  </div>

  <!-- Estado: Erro -->
  <div *ngIf="state === 'error'" class="pair-state pair-state-error">
    <div class="error-icon-wrapper">
      <i class="pi pi-exclamation-triangle error-icon"></i>
    </div>
    <p class="error-message">{{ errorMessage }}</p>
    <div class="pair-actions">
      <p-button
        [label]="'vcuPair.dialog.retry' | transloco"
        icon="pi pi-refresh"
        severity="danger"
        [raised]="true"
        (click)="generateCode()"
        styleClass="pair-action-btn"
      ></p-button>
      <p-button
        [label]="'vcuPair.dialog.cancel' | transloco"
        severity="secondary"
        [raised]="true"
        (click)="closeDialog()"
        styleClass="pair-action-btn"
      ></p-button>
    </div>
  </div>
</p-dialog>
